import ListingPricing from './ListingPricing';

export default ListingPricing;
